import Vue from "vue";
import Vuex from "vuex";
import userInfo from "@/store/userInfo";
import examination from "@/store/examination";
import problemdata from "@/store/problemdata";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

export default new Vuex.Store({
  //用于初始化和存储数据，不支持修改，this.$store.state('参数')
  state: {},
  //用于修改state中的值，this.$store.commit('方法名'，参数)
  mutations: {},
  //异步对state的状态进行改变,this.$store.dispatch('方法名'，参数)
  actions: {},
  //用于将不同的模块注册到store中使用
  modules: {
    userInfo,
    examination,
    problemdata
  },
  //计算属性，对state中的数据进行二次运算，获取新的属性值，获取方式this.$store.getters.dome
  getters: {},
  //插件,数据持久化
  plugins: [createPersistedState()]
});
